var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Footer'),(_vm.isMagenta)?_c('tmo-digital-footer'):_c('tmo-digital-footer',{attrs:{"brand":"metro","client-id":"metro"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }